import React from 'react';
import { Field, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { Color, UpdateCategory } from '../../../../server-types';
import FormWrapper from '../../../../components/forms/FormWrapper';
import { InputField, SelectField } from '../../../../components/forms/fields';
import { mapEnumOptions, mapOptions } from '../../../../utils';
import { Typography } from '../../../../ui-kit';
import { CategoryFormProps } from './types';
import { categoryValidationSchema } from './validation';
import { ColorInput, ColorMarker } from './style';

const CategoryForm = ({
    submitText,
    onSubmit,
    categories,
    initialValues = {
        name: '',
        description: '',
        parentCategoryId: '',
    },
    isLoading,
}: CategoryFormProps) => {
    const categoriesOptions = mapOptions(categories);
    const { t } = useTranslation();
    const categoryColorOptions = mapEnumOptions(t)(Color);
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={categoryValidationSchema}
        >
            {formikProps => (
                <FormWrapper disabled={isLoading} submitText={submitText} isSubmitting={formikProps.isSubmitting}>
                    <Box display='flex' alignItems='center'>
                        {formikProps.values.color
                        ? (
                            <ColorMarker mr={1.5} color={formikProps.values.color} />
                        ) : null}
                        <InputField<UpdateCategory>
                            name="name"
                            label={t('Name')}
                            formikProps={formikProps}
                            required
                        />
                    </Box>
                    {formikProps.values.parentCategoryId
                        ? (
                            <SelectField
                                showEmpty
                                variant='outlined'
                                options={categoriesOptions}
                                name='parentCategoryId'
                                label={t('Parent Category')}
                                formikProps={formikProps}
                            />
                        )
                        : (
                            <Box>
                                <Typography uppercase paragraph variant='caption'>{t('category color')}</Typography>
                                <Box mx={-0.5} display='flex'>
                                    {categoryColorOptions.map(({ id, name }) => (
                                        <Field
                                            key={id}
                                            as={ColorInput}
                                            type="radio"
                                            name="color"
                                            value={name}
                                            formikProps={formikProps}
                                        />
                                    ))}
                                </Box>
                            </Box>
                    )}
                </FormWrapper>
      )}
        </Formik>
    );
};

export default CategoryForm;
